var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FAF9F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9988 22C38.2348 22 33.5488 26.686 33.5488 32.45C33.5488 38.104 37.9708 42.68 43.7348 42.878C43.9108 42.856 44.0868 42.856 44.2188 42.878C44.2628 42.878 44.2848 42.878 44.3288 42.878C44.3508 42.878 44.3508 42.878 44.3728 42.878C50.0048 42.68 54.4268 38.104 54.4488 32.45C54.4488 26.686 49.7628 22 43.9988 22Z",
    fill: "#635A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1757 48.7301C49.0377 44.6381 39.0277 44.6381 32.8457 48.7301C30.0517 50.6001 28.5117 53.1301 28.5117 55.8361C28.5117 58.5421 30.0517 61.0501 32.8237 62.8981C35.9037 64.9661 39.9517 66.0001 43.9997 66.0001C48.0477 66.0001 52.0957 64.9661 55.1757 62.8981C57.9477 61.0281 59.4877 58.5201 59.4877 55.7921C59.4657 53.0861 57.9477 50.5781 55.1757 48.7301Z",
    fill: "#635A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.937d208459abde643ffbee815c66e16c.svg";
export { ForwardRef as ReactComponent };